
import { defineComponent, onMounted, ref, watch } from 'vue';
export default defineComponent({
    props: {
        block: Boolean,
        color: String,
        loading: Boolean,
    },
    emits: ['click'],
    setup(props, ctx) {
        const handleClick = () => {
            if (props.loading) {
                return
            }
            console.log('click')
            ctx.emit('click')
        }

        return {
            handleClick
        }
    }
})
